export class ObserversForModals {
  constructor (targetElement, targetSearchArea, classToAdd = '', showCaptchaOnModalLoad = false) {
    this.targetSearchArea = targetSearchArea;
    this.targetElement = targetElement;
    this.addedClass = classToAdd;
    this.showCaptchaOnModalLoad = showCaptchaOnModalLoad;
    this.setRecaptchaTime;
    this.isCaptchaResponseCorrect = '';
    this.isCaptchaReady = false;
    this.config = {
      subtree: true,
      childList: true,
      characterData: false,
      attributes: false
    }
  };

  observeDom () {
    const areaToSearch = document.querySelector(this.targetSearchArea);

    const observer = new MutationObserver(() => {
      const targetSearchElem = document.querySelector(this.targetElement);
      const signUpButton = document.querySelector('[ref="signUpButtonRef"] button');
      const isCaptchaContainer = this.addedClass === 'captcha-container';

      if (targetSearchElem) {
        targetSearchElem.classList.add(this.addedClass);

        targetSearchElem.classList.contains('hidden') && this.showTargetElements(targetSearchElem);

        if (isCaptchaContainer) {
          this.hideCaptchaIfCorrect(targetSearchElem)
          this.isCaptchaReady  = true
        } else {
          this.removeScroll(areaToSearch)
        }

        targetSearchElem.addEventListener('mouseup', event => {
          event.stopImmediatePropagation();

          if (!isCaptchaContainer && targetSearchElem) {
            if (this.isCaptchaReady) {
              grecaptcha.reset();
              this.isCaptchaReady = false;
            }
            this.addScroll(areaToSearch);
          } else {
            signUpButton && signUpButton.addEventListener('mouseup', event => {
              event.stopImmediatePropagation();

              if (isCaptchaContainer && targetSearchElem.classList.contains('hidden')) {
                this.showTargetElements(targetSearchElem);
              }
            });
          }
        });
        observer.disconnect();
      }
    });

    observer.observe(areaToSearch, this.config);
  };

  addScroll (element) {
    const isPdf = localStorage.getItem('pdf-viewer-showing');
    if (isPdf) return;

    element.classList.remove('no-scroll');
  }

  removeScroll (element) {
    element.classList.add('no-scroll');
  }

  hideTargetElements (element) {
    element.classList.add('hidden');
  }

  showTargetElements (element) {
    element.classList.remove('hidden');
  }

  hideCaptchaIfCorrect(element) {
    const timer = 700;

    this.setRecaptchaTime = setInterval(() => {
      if (this.isCaptchaResponseCorrect !== '') {
        element.classList.add('hidden');
        clearInterval(this.setRecaptchaTime);

      }
      this.isCaptchaResponseCorrect = grecaptcha.getResponse();
    }, timer);

    element.addEventListener('click', () => {
      if (this.showCaptchaOnModalLoad) return;
      clearInterval(this.setRecaptchaTime);
      this.hideTargetElements(element);
    });
  };

}

export function waitForElementToExist (documentToSearch, selector) {
  return new Promise(resolve => {
    if (documentToSearch.querySelector(selector)) {
      return resolve(documentToSearch.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (documentToSearch.querySelector(selector)) {
        resolve(documentToSearch.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(documentToSearch.body, {
      subtree: true,
      childList: true
    });
  });
}
